<template>
  <router-view />
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
.upload-btn {
  position: absolute !important;
  z-index: 1;
  top: 117px;
  right: 17px;
  background: #ced5ff;
}
.avatar-shadow {
  box-shadow: 0px 0px 10px 0px rgba(50, 12, 112, 0.75);
  -webkit-box-shadow: 0px 0px 10px 0px rgba(50, 12, 112, 0.75);
  -moz-box-shadow: 0px 0px 10px 0px rgba(50, 12, 112, 0.75);
}
.buttonSpan {
  width: 70px;
}
</style>
